// react router e redux
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

// formik
import {
  useFormik,
  FormikProvider,
} from "formik";

// material ui
import {
  Box,
  Grid,
  Button,
  TextField,
  Paper,
  Divider,
  Dialog,
  Alert,
  MenuItem,
  DialogActions,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

// componentes próprios
import Loading from "../../loading";
import MensagemFeedback from "../../mensagemFeedback";
import ModalImg from "../../modalImg";
import ModalImgLink from "../../modalImgLink";
import { apiEmpresa } from "../../../services/apiEmpresa";
import validar from "./validacaoFormulario";

const ListaAnexos = ({
  auth,
  solicitacaoAberta,
  anexosEmpresa,
  anexosProfissionais,
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [erroAoEnviarAnexos, setErroAoEnviarAnexos] = useState(false);
  const [anexosEnviados, setAnexosEnviados] = useState(false);
  const [open, setOpen] = useState({});
  const [openEdit, setOpenEdit] = useState({});
  const [profissionaisPendentes, setProfissionaisPendentes] = useState({});
  const [profissionaisParaValidacao, setProfissionaisParaValidacao] = useState([]);
  const [erroEscala, setErroEscala] = useState(false);
  const [empresaArquivoAlterado, setEmpresaArquivoAlterado] = useState({
    0: false,
    1: false,
    2: false,
  });
  const [profissionalArquivoAlterado, setProfissionalArquivoAlterado] = useState({});
  const [erroEncontrado, setErroEncontrado] = useState(false);

  const validationSchema =
    solicitacaoAberta.status !== "5"
      ? validar({
          empresa: anexosEmpresa.data,
          profissionais: anexosProfissionais,
        })
      : undefined;

  const isAnexoAlterado = (index) => {
    const currentAnexo = formik.values.profissionais[index]?.anexoSelecionado?.anexo;
    const initialAnexo = formik.initialValues.profissionais[index]?.anexoSelecionado?.anexo;
    
    // Se ambos são undefined/null, não houve alteração
    if (!currentAnexo && !initialAnexo) return false;
    
    // Se um existe e outro não, houve alteração
    if (!currentAnexo || !initialAnexo) return true;
    
    // Se currentAnexo é um File (novo upload), sempre é alteração
    if (currentAnexo instanceof File) return true;
    
    // Compara strings (paths)
    return currentAnexo !== initialAnexo;
  };


  const possuiEscala = (profissional) => {
  return profissional?.data?.some(
    (doc) => doc.id === 'ficha_escala'
  );
};

const possuiDemaisDocumentos = (profissional) => {
  return profissional?.data?.some(
    (doc) => doc.id !== 'ficha_escala'
  );
};

  const formik = useFormik({
    initialValues: {
      empresa: anexosEmpresa.data,
      profissionais: anexosProfissionais,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
    //  console.log('onSubmit chamado!');
     // console.log('Profissionais completos:', JSON.stringify(values.profissionais, null, 2));
      setLoading(true);

      if (values.empresa?.length) {
        await enviarEmpresa(values.empresa);
      }

      values.profissionais = values.profissionais.filter(
        (element) => element !== undefined
      );

      let idsProfissionais = [];
      values.profissionais.map((element) => {
        idsProfissionais.push(element.idprofissional);
      });

      if (idsProfissionais.length) {
        await enviarProfissionais(values.profissionais, idsProfissionais);
      }

      setLoading(false);
      navigate(`/empSolic/pagamento/${solicitacaoAberta.solic}`);
    },
  });

  async function enviarEmpresa(values) {
    for (let index = 0; index < values.length; index++) {
      const value = values[index];
      if (value.anexo?.name !== undefined) {
        value.arquivo_de = anexosEmpresa.idempresa;
        const res = await enviarParaApi(value);
        if (!res) {
          setErroEncontrado(true);
        }
      }
    }
    return;
  }

async function enviarProfissionais(values, profissionais) {
  for (let i = 0; i < profissionais.length; i++) {
    
    // Enviar anexo da escala (se for novo arquivo)
    if (values[i].anexoEscalaSelecionado?.anexo && 
        typeof values[i].anexoEscalaSelecionado.anexo !== 'string' &&
        values[i].anexoEscalaSelecionado.anexo instanceof File) {
            
      const dadosEscala = {
        ...values[i].anexoEscalaSelecionado,
        tipo: "ficha_escala",
        arquivo_de: values[i].idprofissional
      };
      
      await enviarParaApi(dadosEscala);
    }

    // Enviar outros documentos (se for novo arquivo)
    if (values[i].anexoSelecionado?.anexo && 
        typeof values[i].anexoSelecionado.anexo !== 'string' &&
        values[i].anexoSelecionado.anexo instanceof File) {
      
    //  console.log(`Enviando outro documento do profissional ${i}`);
      
      const dadosDocumento = {
        ...values[i].anexoSelecionado,
        tipo: values[i].anexoSelecionado.tipo || values[i].anexoSelecionado.id,
        arquivo_de: values[i].idprofissional
      };
      
      await enviarParaApi(dadosDocumento);
    }
  }
}

// Função para verificar se há alterações nos anexos
const verificarAlteracoes = () => {


  // Verifica alterações na empresa
  if (formik.values.empresa) {
    for (let i = 0; i < formik.values.empresa.length; i++) {
      const currentAnexo = formik.values.empresa[i]?.anexo;
      const initialAnexo = formik.initialValues.empresa[i]?.anexo;
      
      if (currentAnexo instanceof File) return true;
      if (currentAnexo !== initialAnexo) return true;
    }
  }

  
  // Verifica alterações nos profissionais
  if (formik.values.profissionais) {
    for (let i = 0; i < formik.values.profissionais.length; i++) {
      const prof = formik.values.profissionais[i];
      const initialProf = formik.initialValues.profissionais[i];
      
      if (!prof || !initialProf) continue;
      
      // Verifica se este profissional tem documentos pendentes (anexo === null)
      const temDocumentoPendente = prof?.data?.some((doc) => 
        doc.anexo === null && doc.status !== null // status indica que precisa ser enviado
      );

      // // Se não tem documento pendente, pula este profissional
      // if (!temDocumentoPendente) {
      //   console.log(`Profissional ${i} não tem documentos pendentes, ignorando`);
      //   continue;
      // }
      
      // ESCALA
      const currentEscala =
        prof?.anexoEscalaSelecionado?.anexo;

      if (currentEscala instanceof File) {
        //console.log('ARQUIVO NOVO DE ESCALA ENCONTRADO');
        return true;
      }

      // Verifica outros anexos
      const currentAnexo = prof?.anexoSelecionado?.anexo;
      const initialAnexo = initialProf?.anexoSelecionado?.anexo;
      const currentId = prof?.anexoSelecionado?.id;
      
      if (currentAnexo instanceof File) {
        //console.log('Arquivo normal encontrado');
        return true;
      }
      if (currentAnexo !== initialAnexo && (currentAnexo || initialAnexo)) {
       // console.log('Anexo normal alterado');
        return true;
      }
      
      // Considera a seleção do tipo de documento como alteração
      if (currentId && currentId !== "") {
        //console.log('ID do documento selecionado');
        return true;
      }
    }
  }
  
  //console.log('Nenhuma alteração encontrada');
  return false;
};

  const enviarParaApi = async (value) => {
    const { anexo, id, arquivo_de } = value;

    let formData = new FormData();
    formData.append("anexo", anexo);
    formData.append("tipo_arquivo", id ? id : value.tipo);
    formData.append("solicitacaoid", solicitacaoAberta.solic);
    formData.append("usr_upload", auth.idusuario);
    formData.append("tipo_usr", auth.tipoUsuario === "empresa" ? 1 : 3);
    formData.append("arquivo_de", arquivo_de);

    try {
      const res = await apiEmpresa.post("/attach", formData, {
        headers: {
          ContentType: "multipart/form-data",
        },
      });
      return res.code === undefined;
    } catch (error) {
      return false;
    }
  };

  const handleOpen = (e) => {
    setOpen({ ...open, [e]: !open[e] });
  };

const cancelarEdicao = (index, e, tipo, subtipo = null) => {
  if (tipo === 'empresa') {
    formik.setFieldValue(
      `empresa[${index}].anexo`,
      formik.initialValues.empresa[index]?.anexo
    );
  }

  if (tipo === 'profissionais') {
    if (subtipo === 'escala') {
      formik.setFieldValue(
        `profissionais[${index}].anexoEscalaSelecionado.anexo`,
        formik.initialValues.profissionais[index]
          ?.anexoEscalaSelecionado?.anexo
      );

      formik.setFieldValue(
        `profissionais[${index}].anexoEscalaSelecionado.id`,
        formik.initialValues.profissionais[index]
          ?.anexoEscalaSelecionado?.id
      );
    } else {
      formik.setFieldValue(
        `profissionais[${index}].anexoSelecionado.anexo`,
        formik.initialValues.profissionais[index]
          ?.anexoSelecionado?.anexo
      );

      formik.setFieldValue(
        `profissionais[${index}].anexoSelecionado.id`,
        formik.initialValues.profissionais[index]
          ?.anexoSelecionado?.id
      );
    }
  }

  handleOpenEdit(e);
  setLoading(false);
};

  const handleOpenEdit = (e) => {
    setOpenEdit({ ...openEdit, [e]: !openEdit[e] });
  };

  const deletarArquivoTemporario = (name) => {
    formik.setFieldValue(name, null);
  };

const confirmArquivoAlterado = (tipoEstab, indexArquivo, dialogKey) => {
  //console.log('confirmArquivoAlterado:', tipoEstab, indexArquivo, dialogKey);
  
  if (tipoEstab === "empresa") {
    let anexos = { ...empresaArquivoAlterado };
    anexos[indexArquivo] = true;
    setEmpresaArquivoAlterado(anexos);
  }
  if (tipoEstab === "profissionais") {
    let anexos = { ...profissionalArquivoAlterado };
    anexos[indexArquivo] = true;
    setProfissionalArquivoAlterado(anexos);
  }
  
  handleOpenEdit(dialogKey); // Usa a chave correta do Dialog
};

  useEffect(() => {
    let profPendentes = {};
    anexosProfissionais
      .filter((element) =>
        element.data.every(
          (anexo) => anexo.anexo === null || anexo.status !== null
        )
      )
      .map((e) => {
        profPendentes = {
          ...profPendentes,
          [e.idprofissional]: e,
        };
      });
    setProfissionaisPendentes(profPendentes);
  }, []);

const enviar = async () => {
  formik.values.profissionais.forEach((prof, index) => {
 //   console.log('PROFISSIONAL:', index, prof.nome);
 //   console.log('Possui escala:', possuiEscala(prof));
 //   console.log('Possui demais documentos:', possuiDemaisDocumentos(prof));
  });

  const errors = await formik.validateForm();

  console.log('Erros de validação:', errors);

  if (Object.keys(errors).length === 0) {
    formik.submitForm();
  }
};

  const alteraAnexoProfissional = async (anexo, index, a, tipoAnexo) => {
  //    console.log('ALTERANDO ANEXO');
  //console.log('tipo:', tipoAnexo);
  //console.log('index:', index);
  //console.log('arquivo:', anexo);
  //console.log('arquivo é File:', anexo instanceof File);
    if (tipoAnexo === "escala") {
      await formik.setFieldValue(
        `profissionais[${index}].anexoEscalaSelecionado.anexo`,
        anexo
      );
      await formik.setFieldValue(
        `profissionais[${index}].anexoEscalaSelecionado.id`,
        a.id
      );
    } else {
      await formik.setFieldValue(
        `profissionais[${index}].anexoSelecionado.anexo`,
        anexo
      );
      await formik.setFieldValue(
        `profissionais[${index}].anexoSelecionado.id`,
        a.id
      );
    }
  };

  const alteraAnexoEmpresa = async (anexo, index, a) => {
    await formik.setFieldValue(`empresa[${index}].anexo`, anexo);
  };

  // Renderizar anexos da empresa
  const renderAnexosEmpresa = () => {
    return anexosEmpresa?.data?.map((a, index) => (
      <Box
        component={Paper}
        variant="outlined"
        sx={{ mb: 2, p: 2 }}
        key={a.titulo}
      >
        {a.anexo !== null ? (
          <>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <Typography variant="subtitle" color="primary.main">
                {a.titulo}
              </Typography>
              <IconButton onClick={() => handleOpen(`ap-emp-${index}`)}>
                <VisibilityIcon />
              </IconButton>
              {a.status && (
                <>
                  <Box
                    sx={{ display: "flex", gap: 2, alignItems: "center" }}
                  >
                    <IconButton
                      onClick={() => handleOpenEdit(`ap-emp-${index}`)}
                    >
                      <EditIcon />
                    </IconButton>
                    {!empresaArquivoAlterado[index] ? (
                      <Alert severity="warning">Documento {a.status}</Alert>
                    ) : (
                      <Alert severity="success">
                        Arquivo pronto para enviar
                      </Alert>
                    )}
                  </Box>
                  <Dialog
                    open={openEdit[`ap-emp-${index}`] || false}
                    onClose={() => handleOpenEdit(`ap-emp-${index}`)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll="paper"
                    fullWidth
                  >
                    <DialogTitle>Anexe o novo documento</DialogTitle>
                    <DialogContent>
                      <Button
                        variant="contained"
                        component="label"
                        color="primary"
                      >
                        <AttachFileIcon /> Anexar arquivo
                        <TextField
                          type="file"
                          inputProps={{
                            accept:
                              "image/jpeg,image/png, image/bmp, application/pdf",
                          }}
                          values={formik.values.empresa?.[index]?.id}
                          name={a.id}
                          id={a.id}
                          onChange={(event) => {
                            alteraAnexoEmpresa(
                              event.currentTarget.files[0],
                              index,
                              a
                            );
                          }}
                          sx={{ display: "none" }}
                        />
                      </Button>
                      {typeof formik.values.empresa[index]?.anexo ===
                      "string" ? (
                        <ModalImgLink
                          link={`${process.env.REACT_APP_BASE_URL}/api4/${a.anexo}`}
                          titulo={a.titulo}
                          tipo={a.tipo}
                          handleClose={() =>
                            cancelarEdicao(index, `ap-emp-${index}`, "empresa")
                          }
                        />
                      ) : (
                        <ModalImg
                          file={formik.values.empresa[index]?.anexo}
                          titulo={a.titulo}
                          handleClose={() =>
                            cancelarEdicao(index, `ap-emp-${index}`, "empresa")
                          }
                        />
                      )}
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={() =>
                          cancelarEdicao(index, `ap-emp-${index}`, "empresa")
                        }
                      >
                        Cancelar
                      </Button>
                      <Button
                        onClick={() =>
                         confirmArquivoAlterado(
                            'empresa',
                            index,
                            `ap-emp-${index}`
                          )
                        }
                      >
                        Ok
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              )}
            </Box>
            <Dialog
              open={open[`ap-emp-${index}`] || false}
              onClose={() => handleOpen(`ap-emp-${index}`)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              scroll="paper"
              fullWidth
            >
              <ModalImgLink
                link={`${process.env.REACT_APP_BASE_URL}/api4/${a.anexo}`}
                titulo={a.titulo}
                tipo={a.tipo}
                handleClose={() => handleOpen(`ap-emp-${index}`)}
              />
            </Dialog>
            <Divider />
          </>
        ) : (
          <Grid container item direction="column" sx={{ gap: 1 }}>
            <Grid item xs={12}>
              <Typography variant="h6">{a.titulo}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              container
              item
              direction="row"
              alignItems="flex-end"
              justifyContent="space-between"
              rowSpacing={1}
            >
              <Grid item xs={12} md={4}>
                <Button variant="contained" component="label" color="primary">
                  <AttachFileIcon /> Anexar arquivo
                  <TextField
                    type="file"
                    inputProps={{
                      accept:
                        "image/jpeg,image/png, image/bmp, application/pdf",
                    }}
                    values={formik.values.empresa?.[index]?.id}
                    name={a.id}
                    id={a.id}
                    onChange={(event) => {
                      alteraAnexoEmpresa(
                        event.currentTarget.files[0],
                        index,
                        a
                      );
                    }}
                    sx={{ display: "none" }}
                  />
                </Button>
                <Box>
                  <small>
                    Tamanho máximo por arquivo 20 MB, nos formatos pdf, jpeg e
                    png
                  </small>
                </Box>
              </Grid>
              <Grid item xs={6} md={4}>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      color: "primary.main",
                      "&:hover": {
                        cursor: "pointer",
                        textDecoration: "underline",
                      },
                    }}
                    onClick={() => handleOpen(`empresa-${index}`)}
                  >
                    {formik.values.empresa[index]?.anexo?.name}
                  </Typography>
                  {formik.values.empresa[index]?.anexo?.name !== undefined && (
                    <IconButton
                      onClick={() =>
                        deletarArquivoTemporario(`empresa[${index}].anexo`)
                      }
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
                </Box>
                <Dialog
                  open={open[`empresa-${index}`] || false}
                  onClose={() => handleOpen(`empresa-${index}`)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  scroll="paper"
                  fullWidth
                >
                  <ModalImg
                    file={formik.values.empresa[index]?.anexo}
                    titulo={a.titulo}
                    handleClose={() => handleOpen(`empresa-${index}`)}
                  />
                </Dialog>
              </Grid>
              <Grid item xs={6} md={4}>
                {formik.errors.empresa?.[index]?.anexo && (
                  <Alert severity="error">
                    {formik.errors.empresa[index].anexo}
                  </Alert>
                )}
                {formik.errors.empresa?.[index] === undefined &&
                formik.values.empresa[index]?.anexo !== null ? (
                  <Alert severity="success">Arquivo pronto para enviar</Alert>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        )}
      </Box>
    ));
  };

  // Renderizar seção de escala
  const renderSecaoEscala = (prof, index) => {
    const anexosEscala = prof.data.filter((a) => a.id === "ficha_escala");
    if (anexosEscala.length === 0) return null;

    const escala = anexosEscala[0];
    const anexoExiste = escala.anexo !== null;

    const temAnexoEscala = !!(
      formik.values &&
      formik.values.profissionais &&
      formik.values.profissionais[index] &&
      formik.values.profissionais[index].anexoEscalaSelecionado
    );   

    //console.log(temAnexoEscala);
    const status = solicitacaoAberta.status;

    

    return (
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            color: "text.secondary",
            mb: 1,
            pb: 0.5,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          📋 Ficha de Escala
        </Typography>

        {anexoExiste ? (
          <Box>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
                pl: 2,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                {escala.anexo?.name || escala.anexo}
              </Typography>
              <IconButton
                size="small"
                onClick={() => handleOpen(`escala-${index}`)}
              >
                <VisibilityIcon fontSize="small" />
              </IconButton>
                {temAnexoEscala ? (
                  <Grid item xs={6} md={4}>
                    <Alert severity='success'>Arquivo pronto para enviar</Alert>
                  </Grid>
                ) : (
                  escala.status && (
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <IconButton
                        size='small'
                        onClick={() => handleOpenEdit(`escala-${index}`)}
                      >
                        <EditIcon fontSize='small' />
                      </IconButton>

                      <Alert severity='warning' sx={{ py: 0 }}>
                        Documento {escala.status}
                      </Alert>
                    </Box>
                  )
                )}
            </Box>

            {/* Dialog de visualização da escala */}
            <Dialog
              open={open[`escala-${index}`] || false}
              onClose={() => handleOpen(`escala-${index}`)}
              scroll="paper"
              fullWidth
            >
              {typeof escala.anexo === "string" ? (
                <ModalImgLink
                  link={`${process.env.REACT_APP_BASE_URL}/api4/${escala.anexo}`}
                  titulo="Ficha de Escala"
                  tipo={escala.tipo}
                  handleClose={() => handleOpen(`escala-${index}`)}
                />
              ) : (
                <ModalImg
                  file={escala.anexo}
                  titulo="Ficha de Escala"
                  handleClose={() => handleOpen(`escala-${index}`)}
                />
              )}
            </Dialog>

            {/* Dialog de edição da escala */}
            <Dialog
              open={openEdit[`escala-${index}`] || false}
              onClose={() => handleOpenEdit(`escala-${index}`)}
              scroll="paper"
              fullWidth
            >
              <DialogTitle>Alterar Ficha de Escala</DialogTitle>
              <DialogContent>
                <Button variant="contained" component="label" color="primary">
                  <AttachFileIcon /> Anexar novo arquivo
                  <TextField
                    type="file"
                    inputProps={{
                      accept:
                        "image/jpeg,image/png, image/bmp, application/pdf",
                    }}
                    onChange={(event) => {
                      alteraAnexoProfissional(
                        event.currentTarget.files[0],
                        index,
                        escala,
                        "escala"
                      );
                    }}
                    sx={{ display: "none" }}
                  />
                </Button>
                {formik.values.profissionais[index]?.anexoEscalaSelecionado
                  ?.anexo && (
                  <ModalImg
                    file={
                      formik.values.profissionais[index]
                        ?.anexoEscalaSelecionado?.anexo
                    }
                    titulo="Ficha de Escala"
                    handleClose={() =>
                      cancelarEdicao(
                        index,
                        `escala-${index}`,
                        'profissionais',
                        'escala'
                      )
                    }
                  />
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() =>
                        cancelarEdicao(
                          index,
                          `escala-${index}`,
                          'profissionais',
                          'escala'
                        )
                      }
                >
                  Cancelar
                </Button>
                <Button
                  onClick={() =>
                    confirmArquivoAlterado("profissionais", `${index}`, `escala-${index}`)
                  }
                >
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        ) : (
          <Box sx={{ pl: 2 }}>
            <Grid
              item
              xs={12}
              md={4}
              sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
            >
              <Button variant='contained' component='label' color='primary'>
                <AttachFileIcon /> Anexar Ficha de Escala

                <TextField
                  type='file'
                  inputProps={{
                    accept: 'image/jpeg,image/png, image/bmp, application/pdf',
                  }}
                  onChange={(event) => {
                    alteraAnexoProfissional(
                      event.currentTarget.files[0],
                      index,
                      escala,
                      'escala'
                    );
                  }}
                  sx={{ display: 'none' }}
                />
              </Button>

                {!temAnexoEscala && status == 7 ? (
                  <Alert severity='error'>
                    Envie a Escala
                  </Alert>
                ) : (
                  <Grid item xs={6} md={4}>
                    <Alert severity='success'>
                      Arquivo pronto para enviar
                    </Alert>
                  </Grid>
                )}
            </Grid>
          </Box>
        )}
      </Box>
    );
  };

  // Renderizar seção de demais documentos
  const renderSecaoDemaisDocumentos = (prof, index) => {
    const anexosNormais = prof.data.filter((a) => a.id !== "ficha_escala");
    if (anexosNormais.length === 0) return null;

    return (
      <Box>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            color: "text.secondary",
            mb: 1,
            pb: 0.5,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          📄 Demais Documentos
        </Typography>

        <Box sx={{ pl: 2 }}>
          <Grid container item direction="column" spacing={2}>
            <Grid item xs={12}>
              <TextField
                size="small"
                select
                label="Selecione o documento"
                margin="normal"
                fullWidth
                id={`profissionais[${index}].anexoSelecionado.id`}
                name={`profissionais[${index}].anexoSelecionado.id`}
                value={
                  formik.values.profissionais[index]?.anexoSelecionado?.id ||
                  ""
                }
                onChange={formik.handleChange}
                error={
                  formik.touched.profissionais?.[index]?.anexoSelecionado
                    ?.id &&
                  Boolean(
                    formik.errors.profissionais?.[index]?.anexoSelecionado?.id
                  )
                }
                helperText={
                  formik.touched.profissionais?.[index]?.anexoSelecionado
                    ?.id &&
                  formik.errors.profissionais?.[index]?.anexoSelecionado?.id
                }
              >
                <MenuItem value="">
                  <em>Selecione...</em>
                </MenuItem>
                {anexosNormais.map((ap) => (
                  <MenuItem key={ap.id} value={ap.id}>
                    {ap.titulo}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid
              container
              item
              direction="row"
              alignItems="flex-end"
              justifyContent="space-between"
              rowSpacing={1}
            >
              <Grid item xs={12} md={4}>
                <Button variant="contained" component="label" color="primary">
                  <AttachFileIcon /> Anexar arquivo
                  <TextField
                    type="file"
                    inputProps={{
                      accept:
                        "image/jpeg,image/png, image/bmp, application/pdf",
                    }}
                    name={`profissionais[${index}].anexoSelecionado.anexo`}
                    id={`profissionais[${index}].anexoSelecionado.anexo`}
                    onChange={(event) => {
                      formik.setFieldValue(
                        `profissionais[${index}].anexoSelecionado.anexo`,
                        event.currentTarget.files[0]
                      );
                    }}
                    sx={{ display: "none" }}
                  />
                </Button>
                <Box>
                  <small>
                    Tamanho máximo por arquivo 20 MB, nos formatos pdf, jpeg e
                    png
                  </small>
                </Box>
              </Grid>
              <Grid item xs={6} md={4}>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      color: "primary.main",
                      "&:hover": {
                        cursor: "pointer",
                        textDecoration: "underline",
                      },
                    }}
                    onClick={() => handleOpen(`profissional-${index}`)}
                  >
                    {
                      formik.values.profissionais[index]?.anexoSelecionado
                        ?.anexo?.name
                    }
                  </Typography>
                  {formik.values.profissionais[index]?.anexoSelecionado?.anexo
                    ?.name !== undefined && (
                    <IconButton
                      onClick={() =>
                        deletarArquivoTemporario(
                          `profissionais[${index}].anexoSelecionado.anexo`
                        )
                      }
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
                </Box>
                <Dialog
                  open={open[`profissional-${index}`] || false}
                  onClose={() => handleOpen(`profissional-${index}`)}
                  scroll="paper"
                  fullWidth
                >
                  <ModalImg
                    file={
                      formik.values.profissionais[index]?.anexoSelecionado
                        ?.anexo
                    }
                    titulo="Documento"
                    handleClose={() => handleOpen(`profissional-${index}`)}
                  />
                </Dialog>
              </Grid>
              <Grid item xs={6} md={4}>
                {formik.errors.profissionais?.[index]?.anexoSelecionado
                  ?.id && (
                  <Alert severity="error">
                    {
                      formik.errors.profissionais?.[index]?.anexoSelecionado
                        ?.id
                    }
                  </Alert>
                )}
                {formik.errors.profissionais?.[index]?.anexoSelecionado
                  ?.anexo && (
                  <Alert severity="error">
                    {
                      formik.errors.profissionais?.[index]?.anexoSelecionado
                        ?.anexo
                    }
                  </Alert>
                )}
                {formik.errors.profissionais?.[index]?.anexoSelecionado
                  ?.anexo === undefined &&
                formik.values.profissionais?.[index]?.anexoSelecionado !==
                  undefined &&
                formik.values.profissionais[index]?.anexoSelecionado?.anexo !==
                  null &&
                formik.errors.profissionais?.[index]?.anexoSelecionado?.id ===
                  undefined && (
                  <Alert severity="success">Arquivo pronto para enviar</Alert>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  };

  // Renderizar anexos existentes de demais documentos
  const renderAnexosExistentesNormais = (prof, index) => {
    const anexosNormais = prof.data.filter(
      (a) => a.id !== "ficha_escala" && a.anexo !== null
    );
    if (anexosNormais.length === 0) return null;

    return (
      <Box sx={{ pl: 2 }}>
        {anexosNormais.map((a) => (
          <Box key={a.id}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                {a.titulo}: {a.anexo?.name || a.anexo}
              </Typography>
              <IconButton
                size="small"
                onClick={() => handleOpen(`ap-prof-${index}-${a.id}`)}
              >
                <VisibilityIcon fontSize="small" />
              </IconButton>
              {a.status && (
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <IconButton
                    size="small"
                    onClick={() => handleOpenEdit(`ap-prof-${index}-${a.id}`)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  {!profissionalArquivoAlterado[index] ? (
                    <Alert severity="warning" sx={{ py: 0 }}>
                      Documento {a.status}
                    </Alert>
                  ) : (
                    <Alert severity="success" sx={{ py: 0 }}>
                      Arquivo pronto para enviar
                    </Alert>
                  )}
                </Box>
              )}
            </Box>

            {/* Dialog de visualização */}
            <Dialog
              open={open[`ap-prof-${index}-${a.id}`] || false}
              onClose={() => handleOpen(`ap-prof-${index}-${a.id}`)}
              scroll="paper"
              fullWidth
            >
              <ModalImgLink
                link={`${process.env.REACT_APP_BASE_URL}/api4/${a.anexo}`}
                titulo={a.titulo}
                tipo={a.tipo}
                handleClose={() => handleOpen(`ap-prof-${index}-${a.id}`)}
              />
            </Dialog>

            {/* Dialog de edição */}
            <Dialog
              open={openEdit[`ap-prof-${index}-${a.id}`] || false}
              onClose={() => handleOpenEdit(`ap-prof-${index}-${a.id}`)}
              scroll="paper"
              fullWidth
            >
              <DialogTitle>Anexe o novo documento</DialogTitle>
              <DialogContent>
                <Button variant="contained" component="label" color="primary">
                  <AttachFileIcon /> Anexar arquivo
                  <TextField
                    type="file"
                    inputProps={{
                      accept:
                        "image/jpeg,image/png, image/bmp, application/pdf",
                    }}
                    onChange={(event) => {
                      alteraAnexoProfissional(
                        event.currentTarget.files[0],
                        index,
                        a,
                        "normal"
                      );
                    }}
                    sx={{ display: "none" }}
                  />
                </Button>
                {typeof a.anexo === "string" &&
                formik.values.profissionais[index]?.anexoSelecionado?.anexo ===
                  null ? (
                  <ModalImgLink
                    link={`${process.env.REACT_APP_BASE_URL}/api4/${a.anexo}`}
                    titulo={a.titulo}
                    tipo={a.tipo}
                    handleClose={() =>
                      cancelarEdicao(
                        index,
                        `ap-prof-${index}-${a.id}`,
                        "profissionais"
                      )
                    }
                  />
                ) : (
                  <ModalImg
                    file={
                      formik.values.profissionais[index]?.anexoSelecionado
                        ?.anexo
                    }
                    titulo={a.titulo}
                    handleClose={() =>
                      cancelarEdicao(
                        index,
                        `ap-prof-${index}-${a.id}`,
                        "profissionais"
                      )
                    }
                  />
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() =>
                    cancelarEdicao(
                      index,
                      `ap-prof-${index}-${a.id}`,
                      "profissionais"
                    )
                  }
                >
                  Cancelar
                </Button>
                <Button
                    onClick={() =>
                      confirmArquivoAlterado("profissionais", `${index}`, `ap-prof-${index}-${a.id}`)
                    }
                    disabled={!isAnexoAlterado(index)}
                  >
                    Ok
              </Button>
              </DialogActions>
            </Dialog>
          </Box>
        ))}
        <Divider sx={{ my: 1 }} />
      </Box>
    );
  };

  return (
    <>
      <MensagemFeedback
        open={erroAoEnviarAnexos}
        color="error"
        msg="Erro ao enviar anexos! Verifique o tamanho e os formatos suportados."
      />
      <MensagemFeedback
        open={erroEscala}
        color="error"
        msg="É obrigatório anexar a Ficha de Escala antes de avançar."
      />
      <MensagemFeedback
        open={anexosEnviados}
        color="success"
        msg="Anexos enviados com sucesso!"
      />
      <Loading status={loading} />
      <Typography variant="h6">Anexe os documentos</Typography>
      <Box>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit} autoComplete="off">
            {/* Anexos da Empresa */}
            {renderAnexosEmpresa()}

            {/* Anexos dos Profissionais */}
            {anexosProfissionais &&
              anexosProfissionais.length > 0 &&
              anexosProfissionais.map((prof, index) => (
                <Box
                  component={Paper}
                  variant="outlined"
                  sx={{
                    mb: 2,
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                  key={prof.nome || index}
                >
                  <Typography variant="h6">{prof.nome}</Typography>

                  {/* Seção Ficha de Escala */}
                  {renderSecaoEscala(prof, index)}

                  {/* Seção Demais Documentos - Anexos existentes */}
                  {renderAnexosExistentesNormais(prof, index)}

                  {/* Seção Demais Documentos - Upload de novo */}
                  {renderSecaoDemaisDocumentos(prof, index)}
                </Box>
              ))}

            {/* Botões de navegação */}
            <Box
              sx={{
                display: "flex",
                gap: 5,
                justifyContent: "center",
                mb: 2,
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="error"
                onClick={() => navigate("/empSolic/dados")}
              >
                Voltar
              </Button>
              <LoadingButton
                onClick={enviar}
                variant="outlined"
                color="primary"
                disabled={!verificarAlteracoes()}
              >
                Avançar
              </LoadingButton>
            </Box>
          </form>
        </FormikProvider>
      </Box>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.AutenticacaoReducer.autenticacao,
  solicitacao: state.CRTReducer.solicitacao,
  solicitacaoAberta: state.CRTReducer.solicitacaoAberta,
});

export default connect(mapStateToProps)(ListaAnexos);